import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ListType } from '@app/model';
import { AppMenuItem } from '../../util/menu-item';

/**
 * "Add to list" text button with a drop down of the given lists.
 */
@Component({
  selector: 'app-add-to-list-button',
  templateUrl: './add-to-list-button.component.html',
  styleUrls: ['./add-to-list-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddToListButtonComponent implements OnChanges {
  @Input() lists: ListType[] | null = [];
  @Output() listSelected = new EventEmitter<ListType>();

  public items: AppMenuItem[] = [];

  ngOnChanges(): void {
    const lists = this.lists || [];
    this.items = lists.length
      ? lists.map((list) => ({
          label: list.name,
          command: () => this.listSelected.emit(list),
        }))
      : [{ label: 'No data to display', disabled: true }];
  }
}
